import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((_theme) => ({
  root: {
    minHeight: 300,
    paddingBottom: 50,
    position: 'relative',
  },

  toolbar: {
    marginBottom: 20,
  },

  title: {
    flexGrow: 1,
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  autocomplete: {
    marginTop: 20,
    marginBottom: 20,
    width: 300,
  }
}));

export default useStyles;
